import { Box, useMediaQuery } from '@material-ui/core';
import { createStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import NavBar from './NavBar';

const useStyles = makeStyles((theme: Theme) =>
createStyles({
  careerPageRoot: {
  },
}),
);

export default function PageCareers() {
  const theme = useTheme();
  const isMdOrUp = useMediaQuery(theme.breakpoints.up("md"));
  const classes = useStyles();

  const elements: JSX.Element[] = [];
  elements.push(
    <NavBar transparentAtTop={true} coloredAtTop={false}  largerTitleAtTop={true} transparent={false}
    />)

  elements.push(
    <Box className={classes.careerPageRoot}>
      <img alt='section-1' src={isMdOrUp ? 'https://studiosclo.uk/general/CompanyProfile_Desktop_01_4.jpg' : 'https://studiosclo.uk/general/CompanyProfile_Mobile_01_3.jpg'}
      style={{
        width: '100%',
        marginTop: isMdOrUp ? '0vw' : '27vw'
      }}
      />
      <img alt='section-2' src={isMdOrUp ? 'https://studiosclo.uk/general/CompanyProfile_Desktop_02.jpg' : 'https://studiosclo.uk/general/CompanyProfile_Mobile_02.jpg'}
      style={{
        width: '100%'
      }}
      />
      <img alt='section-3' src={isMdOrUp ? 'https://studiosclo.uk/general/CompanyProfile_Desktop_03.jpg' : 'https://studiosclo.uk/general/CompanyProfile_Mobile_03.jpg'}
      style={{
        width: '100%'
      }}
      />
    </Box>
  );

  return (
    <Box>
      {elements}
    </Box>
  )
}